import { createAction } from '@reduxjs/toolkit';

import { OPEN_FRAME, CLOSE_FRAME } from './index';

export const openFrame = createAction<{ contentId: string }>(OPEN_FRAME);
export const closeFrame = createAction(CLOSE_FRAME);
